import type { PImage, PContainer } from '../engine/aliases'
import { common } from './common-sidecar'
import { fi32, IFrameInfo, IRawFrameInfo } from './frameInfo'
import { preloader } from './preloader-sidecar'

let frameSets: Phaser.Textures.Frame[][] = []

export function create() {
  // let num = 17
  // let scene = common.getScene()

  let sources = preloader.spriteMapSources

  frameSets.push([]) // frames index 0 ...
  frameSets.push([]) // 1
  // frameSets.push(slice(sources[1 - 1], 17, 32 + 1))
  frameSets.push(slice(sources[2 - 1], 45, 20 - 1))
  frameSets.push(slice(sources[3 - 1], 22, 20 - 2))
  frameSets.push(slice(sources[4 - 1], 22, 20 - 2))
  frameSets.push(slice(sources[5 - 1], 22, 20 - 2))
  frameSets.push([])
  frameSets.push([])
  // frameSets.push(slice2(sources[6 - 1], 24 + 1, 15 + 2)) // 6
  // frameSets.push(slice2(sources[7 - 1], 23 + 1, 16 + 2)) // 7
  frameSets.push(slice2(sources[8 - 1], 38 + 1, 8 + 2))
  frameSets.push(sliceAbi(sources[9 - 1], 6 + 2 + 1))
  frameSets.push(sliceAbi(sources[10 - 1], 15 + 2 + 1))
  frameSets.push(sliceAbi(sources[11 - 1], 15 + 2 + 1))
  frameSets.push(sliceAbi(sources[12 - 1], 17 + 2 + 1))
  frameSets.push(sliceAbi(sources[13 - 1], 15 + 2 + 1))
  frameSets.push(sliceAbi(sources[14 - 1], 16 + 2 + 1))

  frameSets.push(sliceAbi(sources[15 - 1], 16 + 2 + 1))

  // frameSets.push(slice2(sources[16 - 1], 14 + 3, 8 + 4 + 2))

  // frameSets.push(slice('2-16', 17, 16 + 1))
  // frameSets.push(slice('3-16', 17, 16 + 1))

  // for (let j = 0; j < num; j++) {
  //   for (let i = 0; i < num; i++) {
  //     let f = new Phaser.Textures.Frame(
  //       scene.game.textures.get('1-32'),
  //       i + j * num,
  //       0,
  //       2 + i * (33 + 3),
  //       2 + j * (33 + 3),
  //       33,
  //       33,
  //     )
  //     frames1.push(f)
  //   }
  // }
}

export function slice(source: string, num: number, size: number) {
  let frames: Phaser.Textures.Frame[] = []
  let scene = common.getPhaserScene()
  let tex = scene.game.textures.get(source)
  for (let j = 0; j < num; j++) {
    for (let i = 0; i < num; i++) {
      let f = new Phaser.Textures.Frame(
        tex,
        i + j * num,
        0,
        2 + i * (size + 3),
        2 + j * (size + 3),
        size,
        size,
      )
      frames.push(f)
    }
  }
  return frames
}
export function slice2(source: string, num: number, size: number) {
  let frames: Phaser.Textures.Frame[] = []
  let scene = common.getPhaserScene()
  let tex = scene.game.textures.get(source)
  for (let j = 0; j < num; j++) {
    for (let i = 0; i < num; i++) {
      let f = new Phaser.Textures.Frame(
        tex,
        i + j * num,
        0,
        2 + i * (size + 3),
        2 + j * (size + 3),
        size,
        size,
      )
      frames.push(f)
    }
  }
  return frames
}

export function sliceAbi(source: string, height: number) {
  let frames: Phaser.Textures.Frame[] = []
  let scene = common.getPhaserScene()

  let size = height - 2 - 1

  let tex = scene.game.textures.get(source)
  let texHeight = tex.get(tex.firstFrame).height
  let texWidth = tex.get(tex.firstFrame).width

  let num = Math.ceil(texHeight / height)
  // console.log('abi text height', texHeight, num, size, height)
  for (let j = 0; j < num; j++) {
    let f = new Phaser.Textures.Frame(
      tex,
      j * num,
      0,
      1,
      1 + j * height,
      texWidth - 2,
      size,
    )
    frames.push(f)
  }
  return frames
}

export function sliceRawFrame(
  source: string,
  x: number,
  y: number,
  w: number,
  h: number,
) {
  let scene = common.getPhaserScene()
  let f = new Phaser.Textures.Frame(
    scene.game.textures.get(source),
    `sr-${y}-${x}-${h}-${w}`,
    0,
    x,
    y,
    w,
    h,
  )
  return f
}

export function sliceOff(
  source: string,
  size: number,
  y: number,
  x: number,
  h: number,
  w: number,
) {
  // let frames: Phaser.Textures.Frame[] = []
  let scene = common.getPhaserScene()

  let f = new Phaser.Textures.Frame(
    scene.game.textures.get(source),
    `s-${y}-${x}-${h}-${w}`,
    0,
    2 + x * (size + 3),
    2 + y * (size + 3),
    (size + 3) * w - 2,
    (size + 3) * h - 2,
  )
  // frames.push(f)

  return f
}

function f32(i: number, y: number, x: number): Phaser.Textures.Frame {
  let num = 17
  if (i === 1) {
    // num = 45
    throw new Error(`loading from old sprite ${i} ${y} ${x}`)
  }
  if (i === 2) {
    num = 45
  }
  if (i === 3) {
    num = 22
  }
  if (i === 5) {
    num = 22
  }
  if (i === 6) {
    // num = 25
    throw new Error(`loading from old sprite ${i} ${y} ${x}`)
  }
  if (i === 7) {
    // num = 24
    throw new Error(`loading from old sprite ${i} ${y} ${x}`)
  }
  if (i === 8) {
    num = 39
  }
  if (i === 9) {
    num = 42
  }
  return frameSets[i][x + y * num]
}

export function fAbi(i: number, y: number): Phaser.Textures.Frame {
  return frameSets[i][y]
}

export function getFrame(frameInfo: IFrameInfo) {
  let frame = frameInfo.frame
  if (!frame) {
    if (
      (!frameInfo.w || frameInfo.w === 1) &&
      (!frameInfo.h || frameInfo.h === 1)
    ) {
      frameInfo.frame = f32(frameInfo.i, frameInfo.y, frameInfo.x)
    } else {
      // console.log('Slicing!!!')

      let sources = preloader.spriteMapSources

      let source = sources[frameInfo.i - 1]

      frameInfo.frame = sliceOff(
        source,
        32 + 1,
        frameInfo.y,
        frameInfo.x,
        frameInfo.h || 1,
        frameInfo.w || 1,
      )
    }
    frame = frameInfo.frame
  }
  return frame
}

export function getRawFrame(rawFrameInfo: IRawFrameInfo) {
  let frame = rawFrameInfo.frame
  if (!frame) {
    let sources = preloader.spriteMapSources

    let source = sources[rawFrameInfo.i - 1]

    rawFrameInfo.frame = sliceRawFrame(
      source,
      rawFrameInfo.x,
      rawFrameInfo.y,
      rawFrameInfo.w,
      rawFrameInfo.h,
    )

    frame = rawFrameInfo.frame
  }
  return frame
}

export function setFrame(
  image: PImage,
  frameInfo: IFrameInfo,
  anchorX = 0.5,
  anchorY = 0.5,
) {
  let frame = getFrame(frameInfo)
  image.frame = frame
  image.setScale(getScale(frameInfo))
  image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY)
}

export function setFrameBasic(image: PImage, frameInfo: IFrameInfo) {
  let frame = getFrame(frameInfo)
  image.frame = frame
}

export function setRawFrame(
  image: PImage,
  frameInfo: IRawFrameInfo,
  anchorX = 0.5,
  anchorY = 0.5,
) {
  let frame = getRawFrame(frameInfo)
  image.frame = frame
  image.setScale(getScale(frameInfo))
  image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY)
}

export function setRawFrameBasic(
  image: PImage,
  frameInfo: IRawFrameInfo,
  anchorX = 0.5,
  anchorY = 0.5,
) {
  let frame = getRawFrame(frameInfo)
  image.frame = frame
  // image.setScale(getScale(frameInfo))
  image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY)
}

export function getScale(frameInfo: IFrameInfo) {
  let scale = frameInfo.scale || 1
  scale *= 4
  return scale
}

export function createImageFromFrameInfo(
  layer: PContainer,
  frameInfo: IFrameInfo,
  x?: number,
  y?: number,
  scale?: number,
) {
  return createImageFromFrame(
    layer,
    getFrame(frameInfo),
    x || 0,
    y || 0,
    scale ?? getScale(frameInfo),
  )
}

export function createImageFromRawFrameInfo(
  layer: PContainer,
  rawFrameInfo: IRawFrameInfo,
  x: number,
  y: number,
  scale: number,
) {
  return createImageFromFrame(
    layer,
    getRawFrame(rawFrameInfo),
    x,
    y,
    scale ?? getScale(rawFrameInfo),
  )
}

export function createImageFromFrame(
  layer: PContainer,
  frame: Phaser.Textures.Frame,
  x: number,
  y: number,
  scale: number = 1,
) {
  let scene = common.getPhaserScene()
  let image = scene.add.image(0, 0, '')
  layer.add(image)
  image.width = frame.width
  image.height = frame.height
  image.frame = frame
  image.originX = 0.5
  image.originY = 0.5
  image.x = x
  image.y = y
  if (scale) {
    image.setScale(scale)
  }
  image.setDisplayOrigin(frame.width / 2, frame.height / 2)

  return image
}

export const createFiRow = (i: number, y: number, x: number, w: number) => {
  let fis: IFrameInfo[] = []
  for (let idx = 0; idx < w; idx++) {
    fis.push(fi32(i, y, x + idx))
  }
  return fis
}
